<template>
  <div class="device-list">
    <el-card>
      <div slot="header">
        <div class="header-actions">
          <span><span class="back-font" @click="goback" style="color: #fff;"> <i class="el-icon-arrow-left"></i>返回</span>{{ deviceName }}-传感器列表</span>
          <el-button type="primary" icon="el-icon-plus" @click="handleAddDevice">新增传感器</el-button>
        </div>
      </div>
      <div class="filter-bar">
        <el-input placeholder="请输入传感器名称" v-model="searchKeyword" prefix-icon="el-icon-search"
          style="width: 300px;"></el-input>
        <!-- <el-button type="primary" style="margin-left: 10px;" @click="handleSearch">搜索</el-button> -->
      </div>
      <el-table :data="pagedDevices" border style="width: 100%;">

        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="typeId" label="传感器ID"></el-table-column>
        <!-- <el-table-column prop="code" label="传感器编码" width="230"></el-table-column> -->
        <el-table-column prop="name" label="传感器名称">
          <!-- <template slot-scope="scope">
            <span> {{ scope.row.name }}{{ scope.row.no }}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="no" label="传感器序号"></el-table-column>
        <el-table-column prop="unit" label="传感器单位"></el-table-column>

        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="text" @click="handleViewDetails(scope.row)">查看传感器</el-button> -->
            <el-row type="flex" :gutter="10" align="center" >
              <el-button size="mini" type="text" @click="handleEditDevice(scope.row)">编辑</el-button>
              <el-button size="mini" type="text" @click="openTriggerDrawer(scope.row)">触发规则</el-button>
              <el-button size="mini" type="text" style="color: #f56c6c;" @click="handleDeleteDevice(scope.row.id)">删除</el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" style="margin-top: 15px; text-align: right;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="filteredDevices.length"></el-pagination>
      </div>
    </el-card>

    <!-- 新增传感器信息弹窗 -->
    <el-dialog title="新增传感器信息" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false"
      :destroy-on-close="true">
      <el-form ref="deviceForm" :model="deviceForm" :rules="rules" label-width="120px" class="device-form">
        <!-- 传感器名称 -->
        <el-form-item label="传感器名称" prop="name">
          <el-input v-model="deviceForm.name" placeholder="请输入传感器名称" maxlength="50" show-word-limit></el-input>
        </el-form-item>

        <!-- 传感器序号 -->
        <el-form-item label="传感器序号" prop="no">
          <el-input v-model="deviceForm.no" placeholder="传感器序号" maxlength="10" show-word-limit></el-input>
        </el-form-item>

        <!-- 传感器类型 -->
        <el-form-item label="传感器类型" prop="type">
          <el-select v-model="deviceForm.type" placeholder="请选择传感器类型" clearable>
            <el-option v-for="item in deviceTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelModels">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>


    <!-- 修改传感器信息弹窗 -->
    <el-dialog title="修改传感器信息" :visible.sync="dialogVisibleEdit" width="500px" :close-on-click-modal="false"
      :destroy-on-close="true">
      <el-form ref="deviceFormEdit" :model="deviceFormEdit" :rules="rulesTwo" label-width="120px" class="device-form">
        <!-- 传感器名称 -->
        <el-form-item label="传感器名称" prop="name">
          <el-input v-model="deviceFormEdit.name" placeholder="请输入传感器名称" maxlength="50" show-word-limit></el-input>
        </el-form-item>

        <!-- 传感器编码 -->
        <el-form-item label="传感器序号" prop="no">
          <el-input v-model="deviceFormEdit.no" placeholder="请输入传感器编码" maxlength="10" show-word-limit></el-input>
        </el-form-item>

        <!-- 传感器类型 -->
        <el-form-item label="传感器类型" prop="type">
          <el-select v-model="deviceFormEdit.type" placeholder="请选择传感器类型" clearable>
            <el-option v-for="item in deviceTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleEdit = false">取消</el-button>
        <el-button type="primary" @click="handleEditSave">保存</el-button>
      </div>
    </el-dialog>

    <SensorTrigger ref="triggerRef" />

  </div>
</template>

<script>
import { sensorInfo, addSensor, delSensor, sensorTypeList } from '@/api/index'
import SensorTrigger from "@/components/SensorTrigger.vue";
export default {
  name: 'DeviceList',
  components: {SensorTrigger},
  data() {
    return {
      searchKeyword: '',
      deviceStatus: '',
      deviceType: '',
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      dialogVisibleEdit: false,
      deviceName: this.$route.query.name,
      // 传感器表单数据
      deviceForm: {
        name: '',
        no: '',
        type: ''
      },
      deviceFormEdit: {
        name: '',
        no: '',
        type: ''
      },
      devices: [],
      // 传感器类型选项
      deviceTypes: [],
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: '请输入传感器名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        no: [
          { required: true, message: '请输入传感器序号', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9_-]+$/, message: '编码只能包含字母、数字、下划线和横线', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择传感器类型', trigger: 'change' }
        ]
      },
      rulesTwo: {
        name: [
          { required: true, message: '请输入传感器名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        no: [
          { required: true, message: '请输入传感器序号', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9_-]+$/, message: '编码只能包含字母、数字、下划线和横线', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择传感器类型', trigger: 'change' }
        ]
      },
    }
  },
  computed: {
    // 过滤传感器列表
    filteredDevices() {
      return this.devices.filter(device => {
        const matchesKeyword = device.name.toLowerCase().includes(this.searchKeyword.toLowerCase())
        return matchesKeyword
      })
    },
    // 分页处理
    pagedDevices() {
      const startIndex = (this.currentPage - 1) * this.pageSize
      const endIndex = startIndex + this.pageSize
      return this.filteredDevices.slice(startIndex, endIndex)
    }
  },
  mounted() {
    this.sensorList()
    console.log('query参数：', this.$route.query.id) // { id: 123, name: '测试设备' }
  },
  methods: {

    //点击新增传感器信息
    handleSave() {
      this.$refs.deviceForm.validate(async (valid) => {
        if (valid) {
          // 表单验证通过，执行保存逻辑
          let list = {
            // id: this.$route.query.id,
            typeId: this.deviceForm.type,
            name: this.deviceForm.name,
            no: this.deviceForm.no,
            equipmentId: this.$route.query.id,
            equipmentCode: this.$route.query.code,
          }
          // console.log("111222---", list)
          // return;
          const res = await addSensor(list)
          if (res.code == "0000") {
            this.$message.success('传感器信息保存成功');
            this.$nextTick(() => {
              this.$refs.deviceForm.resetFields();
            });
            this.dialogVisible = false;
            this.sensorList()
          } else {
            // console.log("111222",res)
            this.$message.error(res.message);
          }
        } else {
          // 表单验证失败
          this.$message.error('请完善传感器信息并确保格式正确');
          return false;
        }
      });
    },

    //删除传感器
    handleDeleteDevice(id) {
      this.$confirm('确定要删除该传感器吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delSensor(id)
        if (res.code == "0000") {
          this.devices = this.devices.filter(device => device.id !== id)
          this.$message.success('传感器删除成功')
          this.sensorList()
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    async openTriggerDrawer(item) {
      this.$refs.triggerRef.handleOpen(item.id)
    },



    //修改传感器信息弹框
    async handleEditDevice(device) {
      console.log("111222device", this.deviceFormEdit.name)
      this.dialogVisibleEdit = false; // 先关弹窗，避免DOM干扰
      // 关键：逐个属性赋值，不破坏响应式（因为data里已声明name/code/type）
      this.deviceFormEdit.name = device.name || '';
      this.deviceFormEdit.no = device.no || '';
      this.deviceFormEdit.type = device.typeId || ''; // 直接赋值类型ID，无需循环
      this.deviceFormEdit.id = device.id
      // 确保传感器类型列表加载完成
      await this.sensorType();
      this.dialogVisibleEdit = true;
    },

    //点击保存修改传感器信息
    handleEditSave() {
      this.$refs.deviceFormEdit.validate(async (valid) => {
        if (valid) {
          // 表单验证通过，执行保存逻辑
          let list = {
            name: this.deviceFormEdit.name,
            no: this.deviceFormEdit.no,
            typeId: this.deviceFormEdit.type,
            id: this.deviceFormEdit.id,
            equipmentId: this.$route.query.id,
            equipmentCode: this.$route.query.code,
          }
          //    console.log("111222---", list)
          // return;
          const res = await addSensor(list)
          if (res.code == "0000") {
            this.$message.success('修改传感器信息成功');
            this.$nextTick(() => {
              this.$refs.deviceFormEdit.resetFields();
            });
            this.dialogVisibleEdit = false;
            this.sensorList()
          }
        } else {
          // 表单验证失败
          this.$message.error('请完善传感器信息并确保格式正确');
          return false;
        }
      });
      // console.log("this.deviceFormEdit", this.deviceFormEdit)
    },



    //传感器列表接口
    async sensorList() {
      try {
        let list = {
          "filter": [
            {
              "name": "equipmentId",
              "value": this.$route.query.id,
              "type": "EQ"
            }
          ]
        }
        const res = await sensorInfo(list)
        // 实际项目中使用接口返回的数据
        this.devices = res.result.records
        // this.totalCount = res.result.total
      } catch (error) {
        console.error(error)
      }
    },

    //传感器类型接口
    async sensorType() {
      try {
        const res = await sensorTypeList({});
        this.deviceTypes = res.result.records;
        // 如果类型不一致（比如一个是数字，一个是字符串），统一类型
        this.deviceTypes = this.deviceTypes.map(item => ({
          ...item,
          id: String(item.id) // 统一转为字符串（或Number，看device.categooryId类型）
        }));
        this.deviceFormEdit.type = String(this.deviceFormEdit.type); // 同步类型
      } catch (error) {
        console.error('获取传感器类型失败：', error);
        this.$message.error('加载传感器类型失败，请重试');
      }
    },



    cancelModels() {
      this.dialogVisible = false
    },

    cancelModelsEdit() {
      this.dialogVisibleEdit = false
    },


    handleSearch() {
      // 重置页码
      this.currentPage = 1
    },
    handleSizeChange(val) {
      this.pageSize = val
      // 当页面大小改变时，重置到第一页
      this.currentPage = 1
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    getTypeName(type) {
      const typeMap = {
        temperature: '温度传感器',
        humidity: '湿度传感器',
        switch: '智能开关',
        smoke: '烟雾报警器'
      }
      return typeMap[type] || '未知类型'
    },
    getTypeTagType(type) {
      const typeMap = {
        temperature: 'primary',
        humidity: 'success',
        switch: 'warning',
        smoke: 'info'
      }
      return typeMap[type] || 'default'
    },
    handleAddDevice() {
      // 重置表单
      // this.$nextTick(() => {
      //   this.$refs.deviceForm.resetFields();
      // });
      this.sensorType()
      this.dialogVisible = true;


    },
    handleViewDetails(device) {
      // console.log(device)
      this.$router.push('/sensor');
      // this.$message.info(`查看传感器 ${device.name} 的详情`)

    },

    goback() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>
/* 全局样式 */
.device-list {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* 主卡片样式 */
::v-deep .el-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

::v-deep .el-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

/* 卡片头部 */
::v-deep .el-card__header {
  background-color: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f2f5;
}

.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions span {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  display: flex;
  align-items: center;
}

/* 返回按钮样式 */
.back-font {
  color: #1890ff;
  cursor: pointer;
  margin-right: 15px;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  background: #1890ff;
  color: #fff;
  font-size: 14px;
  width: auto;
}

.back-font:hover {
  background-color: #0f7ae5;
  transform: translateY(-1px);
}

/* 新增按钮样式 */
::v-deep .el-button--primary {
  transition: all 0.2s ease;
}

::v-deep .el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 搜索区域 */
.filter-bar {
  display: flex;
  margin: 20px;
  align-items: center;
}

::v-deep .el-input {
  width: 300px;
  height: 40px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

::v-deep .el-input__inner:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 表格样式 */
::v-deep .el-table {
  margin: 0 20px;
  border-radius: 6px;
  overflow: hidden;
}

::v-deep .el-table th {
  background-color: #f7f8fa;
  font-weight: 500;
  color: #4b5563;
  padding: 12px 0;
}

::v-deep .el-table td {
  padding: 12px 0;
}

::v-deep .el-table__row:nth-child(even) {
  background-color: #fff;
}

::v-deep .el-table__row:nth-child(odd) {
  background-color: #fafafa;
}

::v-deep .el-table__row:hover > td {
  background-color: #f0f7ff !important;
}

::v-deep .el-table__current-row > td {
  background-color: #e6f7ff !important;
}

/* 操作按钮样式 */
::v-deep .el-button--text {
  padding: 4px 8px;
  margin: 0 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

::v-deep .el-button--text:not(.el-button--danger):hover {
  color: #52c41a;
  background-color: rgba(82, 196, 26, 0.1);
}

::v-deep .el-button--text.el-button--danger {
  color: #ff4d4f;
}

::v-deep .el-button--text.el-button--danger:hover {
  background-color: rgba(255, 77, 79, 0.1);
}

/* 分页样式 */
.pagination {
  margin: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f2f5;
  text-align: right;
}

::v-deep .el-pagination {
  font-size: 14px;
}

::v-deep .el-pagination button,
::v-deep .el-pagination span:not([class*='suffix']) {
  height: 32px;
  line-height: 32px;
  min-width: 32px;
  border-radius: 4px;
}

::v-deep .el-pagination .el-pager li {
  margin: 0 3px;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

::v-deep .el-pagination .el-pager li.active {
  background-color: #1890ff;
  color: #fff;
}

/* 表单样式 */
.device-form {
  margin-top: 15px;
}

::v-deep .el-input__inner,
::v-deep .el-select__inner {
  width: 100%;
  border-radius: 6px;
  transition: all 0.3s ease;
}

::v-deep .el-input__inner:focus,
::v-deep .el-select__inner:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 弹窗样式 */
::v-deep .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f2f5;
  background-color: #f7f8fa;
}

::v-deep .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

::v-deep .el-dialog__body {
  padding: 20px;
}

::v-deep .el-dialog__footer {
  padding: 12px 20px;
  border-top: 1px solid #f0f2f5;
}

/* 弹窗按钮 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

::v-deep .dialog-footer .el-button {
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

::v-deep .dialog-footer .el-button:not(.el-button--primary) {
  background-color: #f5f5f5;
  color: #4b5563;
  border-color: #e0e0e0;
}

::v-deep .dialog-footer .el-button:not(.el-button--primary):hover {
  background-color: #e9e9e9;
  color: #374151;
}

::v-deep .dialog-footer .el-button--primary {
  background-color: #1890ff;
  border-color: #1890ff;
}

::v-deep .dialog-footer .el-button--primary:hover {
  background-color: #0f7ae5;
  border-color: #0f7ae5;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 优化表单项间距 */
::v-deep .el-form-item {
  margin-bottom: 20px;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .device-list {
    padding: 10px;
  }

  ::v-deep .el-input {
    width: 100%;
  }

  .header-actions {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .pagination {
    text-align: center;
  }

  ::v-deep .el-table {
    font-size: 13px;
  }

  ::v-deep .el-table .el-table__cell {
    padding: 8px 0;
  }

  ::v-deep .el-button--text {
    padding: 2px 6px;
    font-size: 12px;
  }

  .back-font {
    margin-bottom: 8px;
  }
}
</style>
